import styled from "styled-components";
import {
  scarpaGray400,
  scarpaGray500,
  size,
  skyBlue100,
} from "StylesConstants";

export const FeeBadgeWrapper = styled.div`
  padding: 1rem;
  background: ${skyBlue100};
  border-radius: 8px;
  margin-top: 24px;
  text-align: left;

  .fee__price {
    margin-bottom: 0;
    font-family: Open Sans;
    color: ${scarpaGray500};
    font-weight: 600;
    font-size: 1.5rem;
  }
  .fee__price-label {
    text-align: left;
    margin-bottom: 0;
    font-family: Open Sans;
    color: ${scarpaGray400};
    font-weight: 600;
    font-size: 0.875rem;
  }

  .fee__alert-container {
    display: flex;
    text-align: left;
    flex-direction: row;
    .fee_icon {
      margin-top: 10px;
    }
    .fee__label {
      padding: 12px;
      width: fit-content;
      height: fit-content;
      margin-bottom: 0;
      font-family: Open Sans;
      color: ${scarpaGray500};
      font-weight: 400;
      font-size: 0.875rem;
    }
  }

  @media screen and (min-width: ${size.tablet}) {
    width: 269px;
  }

  @media screen and (min-width: ${size.desktop}) {
    text-align: right;
    width: 330px;
  }
`;
